/**
 * Batch service — centralises all batch-related API calls.
 *
 * Covers: batch creation, batch listing, unbatching operations,
 * and batch info retrieval.
 */
import api from './api'

// ---------------------------------------------------------------------------
// Batch Retrieval
// ---------------------------------------------------------------------------

export function getBatches(campaignId) {
  return api.get(`/batch/getBatches/${campaignId}`)
}

/**
 * Released batches only -- the Reports page batch picker.
 *
 * Deliberately NOT `getBatches` with a client-side filter. A report is a
 * fulfillment document, and a batch that has not been released is still
 * editable and uncharged, so offering one would invite a decorator PO for
 * unauthorized work. The server applies the rule (and enforces it again on
 * the report routes); this call is how the page asks for the safe list
 * rather than filtering an unsafe one.
 */
export function getReleasedBatches(campaignId) {
  return api.get(`/batch/getReleasedBatches/${campaignId}`)
}

export function getBatchInfo(batchId) {
  return api.get(`batch/getBatchInfo/${batchId}`)
}

export function getCampaignHasPendingOrders(campaignId) {
  return api.get(`/batch/getCampaignHasPendingOrders/${campaignId}`)
}

// ---------------------------------------------------------------------------
// Batch Operations
// ---------------------------------------------------------------------------

export function createBatch(data) {
  return api.post('batch/create', data)
}

export function unbatch(batchId) {
  return api.post('/batch/unbatch', { batch_id: batchId })
}

export function unbatchSelectedOrders(batchId, orders) {
  return api.post('/batch/unbatchSelectedOrders', { batch_id: batchId, orders })
}
